
<div class="background blue contenedor2"*ngIf="this.jwtExpired">
  <div class="sub-contenedor">
    <div class="contenedor-circular">
      <img src="../../../../../../assets/svg/logoSigessRedondo.svg" alt="" />
    </div>
    <div class="contenedor-cuadrado">
      <div style="padding-top: 70px">
        <h1>El tiempo para firmar el documento ha expirado solicite nuevamente un link.</h1>
      </div>
      <div style="padding-top: 70px">
        <h2>Recuerde que tiene maximo de tiempo <strong style="font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; font-weight: 900;">1 hora</strong> para firmar desde la generacion del link</h2>
      </div>
    </div>
  </div>
</div>


<div class="background blue contenedor2" *ngIf="this.tipoUsuario.firma != null">
  <div class="sub-contenedor">
    <div class="contenedor-circular">
      <img src="../../../../../../assets/svg/logoSigessRedondo.svg" alt="" />
    </div>
    <div class="contenedor-cuadrado">
      <div style="padding-top: 70px">
        <h2>el documento ya se encuentra firmado</h2>
    </div>
  </div>
</div>
</div>
<div class="background blue contenedor2" *ngIf="this.tipoUsuario.terminoscondiciones == false">
  <div class="sub-contenedor">
    <div class="contenedor-circular">
      <img src="../../../../../../assets/svg/logoSigessRedondo.svg" alt="" />
    </div>
    <div class="contenedor-cuadrado">
      <div style="padding-top: 70px">
        <h2>No acepto terminos y condiciones</h2>
    </div>
  </div>
</div>
</div>
<div id="plantillaAnexo6">
  <table width="90%" style="border-collapse: collapse; margin: auto">
    <tr>
      <th
        rowspan="4"
        style="border: 1px solid #c8c8c8; text-align: center; width: 20%"
      >
        <img style="width: 80%" id="P_empresa_logo" />
      </th>
      <th style="border-top: 1px solid #c8c8c8; text-align: center">ANEXO 6</th>
      <td style="border: 1px solid #c8c8c8; text-align: left">Código</td>
      <td style="border: 1px solid #c8c8c8; text-align: left">SST-PR-03-A6</td>
    </tr>
    <tr>
      <th style="text-align: center">FORMATO SEGUIMIENTO MEDICO</th>
      <td style="border: 1px solid #c8c8c8">Vigente desde</td>
      <td style="border: 1px solid #c8c8c8">Junio de 2016</td>
    </tr>
    <tr>
      <th style="text-align: center">HISTORIA CLINICA OCUPACIONAL</th>
      <td style="border: 1px solid #c8c8c8">Versión</td>
      <td style="border: 1px solid #c8c8c8">0</td>
    </tr>
    <tr>
      <th style="border-bottom: 1px solid #c8c8c8; text-align: center">
        SEGURIDAD Y SALUD EN EL TRABAJO
      </th>
      <td style="border: 1px solid #c8c8c8">Página</td>
      <td style="border: 1px solid #c8c8c8">1 de 1</td>
    </tr>
  </table>
  <br />
  <div style="margin: auto; width: 85%">
    <h3 style="text-align: center">Consentimiento Informado</h3>
    <div style="text-align: justify">
      Con la presente me permito autorizar al área de Seguridad y Salud en el
      Trabajo de la Empresa, para que custodie el resultado de mi evaluación
      médica para su conocimiento y continuidad de los Sistemas de Vigilancia
      Epidemiológica en mi vida laboral, guardando su debida reserva y
      confidencialidad. Lo anterior da cumplimiento a la Resolución 1995 de
      Julio 8 de 1999 y la Resolución 2346 de julio 16 de 2007. La decisión que
      aquí manifiesto la he tomado de manera autónoma, libre y voluntaria, por
      lo cual no se constituye en injerencias indebidas e inconsultas sobre mis
      derechos a la intimidad y al libre desarrollo de mi personalidad.
    </div>
  </div>
  <br />
  <table width="85%" style="border-collapse: collapse; margin: auto">
    <br />

    <tr>
      <td>
        Fecha del seguimiento:&nbsp;
        <label id="P_fechaseguiminto">{{
          this.seguimientoData.fechaSeg | date : "dd/MM/yy"
        }}</label>
      </td>
      <td colspan="3">&nbsp;</td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
    <tr>
      <td colspan="3">
        Nombre:&nbsp;
        <label id="P_nombreApellidos"
          >{{ this.empleadoData?.primerNombre }}
          {{ this.empleadoData?.segundoNombre }}
          {{ this.empleadoData?.primerApellido }}
          {{ this.empleadoData?.segundoApellido }}</label
        >
      </td>
      <td colspan="1">
        Cédula:&nbsp;
        <label id="P_cedula">{{
          this.empleadoData?.numeroIdentificacion
        }}</label>
      </td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>

    <tr>
      <td colspan="2">
        Sección:&nbsp;
        <label id="P_ubicacion">{{ this.empleadoData?.area?.nombre }}</label>
      </td>
      <td colspan="2">
        Oficio:&nbsp; <label id="P_cargo"></label
        >{{ this.empleadoData?.cargo?.nombre }}
      </td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
  </table>
  <div style="margin: auto; width: 85%">
    <div style="text-align: justify">
      <label id="P_textseguimiento"
        >Seguimiento: {{ this.seguimientoData.seguimiento }}</label
      >
    </div>
    <div style="text-align: justify">
      <label id="P_textseguimiento"
        >Tarea: {{ this.seguimientoData.tarea }}</label
      >
    </div>
    <br />
  </div>
  <table width="85%" style="border-collapse: collapse; margin: auto">
    <tr>
      <td>
        <div class="contenedorcanvas">
          <canvas
            id="canvasAprobador"
            #canvasAprobador
            width="300"
            height="150"
            (mousedown)="startDrawingAprobador($event)"
            (mouseup)="stopDrawingAprobador()"
            (mousemove)="draw($event, ctxAprobador)"
            (touchstart)="startDrawingAprobador($event)"
            (touchend)="stopDrawingAprobador()"
            (touchmove)="draw($event, ctxAprobador)"
            [style.pointer-events]="whoSignature === 'medico' ? 'none' : 'auto'"
          ></canvas>
        </div>
        <div
  *ngIf="tipoUsuario.firma === null && tipoUsuario.terminoscondiciones === true"
  style="
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
  "
>
  <div
    class="buttonBase"
    (click)="savePad()"
    [style.pointer-events]="whoSignature === 'medico' ? 'none' : 'auto'"
    [style.opacity]="whoSignature === 'medico' ? '0.5' : '1'"
  >
    Guardar
  </div>

  <div
    class="buttonBaseDelete"
    (click)="clearPadDoctor()"
    [style.pointer-events]="whoSignature === 'medico' ? 'none' : 'auto'"
    [style.opacity]="whoSignature === 'medico' ? '0.5' : '1'"
  >
    Borrar
  </div>
</div>

      </td>
      <td>&nbsp;</td>
      <td>
        <div class="contenedorcanvas">
          <canvas
            id="canvasMedico"
            #canvasMedico
            width="300"
            height="150"
            (mousedown)="startDrawingMedico($event)"
            (mouseup)="stopDrawingMedico()"
            (mousemove)="draw($event, ctxMedico)"
            (touchstart)="startDrawingMedico($event)"
            (touchend)="stopDrawingMedico()"
            (touchmove)="draw($event, ctxMedico)"
            [style.pointer-events]="
              whoSignature === 'aprueba' ? 'none' : 'auto'
            "
          ></canvas>
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-top: 10px;
          "
            *ngIf="tipoUsuario.firma === null && tipoUsuario.terminoscondiciones === true"

        >
          <div
            class="buttonBase"
            (click)="savePad()"
            [style.pointer-events]="
              whoSignature === 'aprueba' ? 'none' : 'auto'
            "
            [style.opacity]="whoSignature === 'aprueba' ? '0.5' : '1'"
          >
            Guardar
          </div>

          <div
            class="buttonBaseDelete"
            (click)="clearPadDoctor()"
            [style.pointer-events]="
              whoSignature === 'aprueba' ? 'none' : 'auto'
            "
            [style.opacity]="whoSignature === 'aprueba' ? '0.5' : '1'"
          >
            Borrar
          </div>

          <!-- <button
              class="p-button-danger"
              label="Borrar"
              pButton
              type="button"
              
              [disabled]="whoSignature === 'aprueba'"
            ></button> -->
          <!-- <button
              class="p-button-success"
              label="Guardar"
              pButton
              type="button"
              (click)="savePad()"
              *ngIf="whoSignature === 'medico'"
            ></button> -->
        </div>
      </td>
      <td>&nbsp;</td>
    </tr>
    <br />
    <tr>
      <td colspan="2">Firma usuario que aprueba el seguimiento:</td>
      <td colspan="2">Firma medico:</td>
    </tr>
    <tr>
      <td colspan="2">Nombre:&nbsp; <label id="P_nombre_aprueba"></label></td>
      <td colspan="2">Nombre:&nbsp; <label id="P_nombre_medico"></label></td>
    </tr>
    <tr>
      <td colspan="2">Cédula:&nbsp; <label id="P_cedula_aprueba"></label></td>
      <td colspan="2">Cédula:&nbsp; <label id="P_cedula_medico"></label></td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
  </table>
</div>


<p-dialog
  [closable]="false"
  [(visible)]="visibleDlg"
  modal="true"
  [style]="{ width: '90%' }"
  *ngIf="this.tipoUsuario.firma === null"
>
  <div class="content">
    <p
      style="
        margin-top: 0px;
        text-align: center;
        font-weight: bold;
        margin: auto;
      "
    >
      A continuación encontrará nuestra política de tratamiento de datos
      personales. Por favor léala cuidadosamente y después especifique si acepta
      los términos:
    </p>
    <br />
    <div style="width: 90%; text-align: justify; margin: auto">
      De conformidad con lo dispuesto en las normas vigentes sobre protección de
      datos personales Ley 1581 de 2012, yo
      <input
        (input)="input()"
        type="text"
        min="8"
        style="width: 25%"
        [(ngModel)]="nombre"
      />
      con C.C.
      <input
        (input)="input()"
        type="number"
        min="4"
        style="width: 25%"
        [(ngModel)]="cedula"
      />
      autorizo libre, expresa e inequívocamente a LER PREVENCION/SIGESS&#174;,
      para que realice la recolección y tratamiento de datos que suministro de
      manera veraz y completa, los cuales serán utilizados para los diferentes
      aspectos relacionados con la gestión del SG-SST en SIGESS&#174;.
    </div>
    <!-- <iframe style="border:solid thin #ccc;" width="700" height="345" src="https://sigess.app/avisoprivacidad.html">
            </iframe> -->
    <div style="margin-top: 10px">
      ¿Acepta los términos?
      <button
        (click)="terminosyCondiciones(true)"
        pButton
        label="SI"
        [disabled]="flagNombre || flagCedula"
      ></button>
      <button
        (click)="terminosyCondiciones(false)"
        pButton
        class="p-button-secondary"
        label="NO"
        [disabled]="flagNombre || flagCedula"
      ></button>
    </div>
  </div>
</p-dialog>

<div class="message-box" *ngIf="mensajeVisible">
  {{ mensaje }}
</div>
